<template>
  <div>
    <Header>
      <template v-slot:left v-if="showBack">
        <FeatherIcon icon="chevron-left" @click="$router.back()" />
      </template>
      業務カテゴリ設定
    </Header>
    <CustomValidationObserver
      tag="div"
      class="my-4 mx-3"
      v-slot="{ handleSubmit }"
      :initialValues="{ workerServiceId }"
    >
      <InfoCard body-class="p-2">
        <p class="text-size-14">
          業務カテゴリを変更することで、対象のお仕事を検索したり、資格登録をしたりすることができるようになります。
        </p>
      </InfoCard>
      <BForm class="mt-4" v-show="workerServiceId">
        <ValidationProvider
          v-slot="validationState"
          name="業務カテゴリ設定"
          rules="required"
          vid="workerServiceId"
        >
          <FormRadioGroup
            name="設定値"
            v-model="workerServiceId"
            :options="workerServiceOptions"
            value="value"
            :validation-state="validationState"
          />
        </ValidationProvider>
        <AppButton block class="mt-4" @click="handleSubmit(onSubmit)">
          設定する
        </AppButton>
      </BForm>
    </CustomValidationObserver>
  </div>
</template>

<script lang="ts">
import AppButton from "@/components/atoms/button/AppButton.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";
import { Component, Vue, Prop } from "vue-facing-decorator";
import { accountService } from "@/app/services/AccountService";
import { showErrorModal, ErrorType } from "@/utils/showErrorModal";
import { authStore } from "@/store/auth";
import FormRadioGroup from "@/components/molecules/form/FormRadioGroup.vue";
import InfoCard from "@/components/atoms/other/InfoCard.vue";
import { orderStore } from "@/store/order";

@Component({
  components: {
    AppButton,
    FeatherIcon,
    Header,
    FormRadioGroup,
    InfoCard
  }
})
export default class SetWorkerServiceTemplate extends Vue {
  @Prop({
    required: true,
    type: Boolean
  })
  showBack!: boolean;

  @Prop({
    required: true,
    type: Boolean
  })
  showFinishDialog!: boolean;

  workerServiceId: number | null = null;

  get workerServiceOptions() {
    return authStore.workerServiceOptionsByProduct;
  }

  created() {
    this.workerServiceId = authStore.workerService.id;
  }

  async finish() {
    if (this.showFinishDialog) {
      await this.$bvModal.msgBoxOk("業務カテゴリを設定しました", {
        okVariant: "success",
        centered: true
      });
    }
    this.$emit("finish");
  }

  async onSubmit() {
    this.$loading.show();
    try {
      if (this.workerServiceId === null) return; // ありえないケース
      await accountService.migrateWorkerService(this.workerServiceId);
      await accountService.updateUserData();
      await orderStore.clearQualificationsFromSearchQuery();
      await this.finish();
    } catch (err) {
      const errorType = err as ErrorType;
      if (
        errorType !== undefined &&
        "response" in errorType &&
        errorType?.response?.data?.nonFieldErrors[0] === "すでに移行済みです"
      ) {
        // このケースは特に問題なし
        // NOTE: 本来、APIがこのエラーを返さないようにすべきだが、現状は古いUIからこのAPIが呼び出されるため変更できない。古いUIがなくなった後にAPIを変更予定
        await this.finish();
      } else {
        showErrorModal(this, errorType);
      }
    } finally {
      this.$loading.hide();
    }
  }
}
</script>
